import actionLogDefinition from './action-log.js';
import appsDefinition from './apps.js';
import featuredAppsDefinition from './featured-apps.js';

const selectorDefinitions = [
  actionLogDefinition,
  appsDefinition,
  featuredAppsDefinition,
];

export default selectorDefinitions;
